
import { defineComponent } from "vue";
import {
  getTotalBalanceVisibility,
  toggleTotalBalanceVisibility,
} from "@/api/dashboard";

export default defineComponent({
  name: "HeroBalanceCard",
  props: {
    label: { type: String, default: "Lifetime Income" },
    amount: { type: [Number, String], default: 0 },
    currencySymbol: { type: String, default: "€" },
    trend: { type: String, default: "" }
  },
  data() {
    return {
      isBalanceVisible: false,
      visibilityReady: false,
      isToggling: false,
    };
  },
  computed: {
    formattedAmount(): string {
      const value = Number(this.amount) || 0;
      return value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  mounted() {
    this.loadTotalBalanceVisibility();
  },
  methods: {
    async loadTotalBalanceVisibility() {
      this.visibilityReady = false;
      try {
        const response = await getTotalBalanceVisibility();
        const visibility = response?.data?.totalBalanceVisibility;
        this.isBalanceVisible = visibility === true || visibility === "true";
      } catch (e) {
        // Endpoint may not exist yet; default to hidden.
        console.error(e);
        this.isBalanceVisible = false;
      } finally {
        this.visibilityReady = true;
      }
    },
    async toggleBalanceVisibility() {
      if (this.isToggling || !this.visibilityReady) return;

      const nextVisible = !this.isBalanceVisible;
      this.isBalanceVisible = nextVisible;
      this.isToggling = true;

      try {
        await toggleTotalBalanceVisibility({
          visible: nextVisible,
        });
      } catch (e) {
        // Endpoint may not exist yet on backend; local toggle still applies.
        console.error(e);
      } finally {
        this.isToggling = false;
      }
    },
  },
});
